import { Modify } from "../utilities/modifyType";
import { LibraryItem } from "./LibraryItem";
import { LibraryItemType } from "./LibraryItemType";

export interface Folder {
    id: string;
    name: string;
    parentId?: string;
    dateAccessed: Date;
    dateCreated: Date;
    dateModified: Date;
    isStarred: boolean;
}

export type SerializedFolder = Modify<Folder, {
    dateAccessed: string;
    dateCreated: string;
    dateModified: string;
}>

export const deserializeFolder = (folder: SerializedFolder): Folder => {
	return {
		...folder,
		dateAccessed: new Date(folder.dateAccessed),
		dateCreated: new Date(folder.dateCreated),
		dateModified: new Date(folder.dateModified)
	};
};

export function convertFolderToLibraryItem(folder: Folder): LibraryItem {
    return {
        ...folder,
        type: LibraryItemType.Folder,
        isShared: false,
        isTemplate: false,
        templateDescription: '',
        templateText: undefined,
        slideExporterAspectRatio: '16x9',
    };
}